import React, { useState } from 'react';
import * as moment from "moment";
import { MobileViewWrapper, TableWrapper } from './orderReportsStyled'
import { SearchWrapper, SelectWrapper } from "web/pages/private/Admin/DashBoard/dashBoardStyled";
import { stateConvert } from "web/components/utils/stateAbbreviation";
import FilterIcon from 'web/assets/svg/MyOrderReportFilterIcon'
import { AiOutlineSearch } from "react-icons/ai";
import DownArrow from 'web/assets/svg/AccordionDownArrow'
import UpArrow from 'web/assets/svg/AccordionUpArrow'
import FilterModal from './FilterModal';
import Pagination from "@material-ui/lab/Pagination";
import Spinner from "web/components/Spinner";
import { greenButton, requestTypeList, selectStyle } from './Constants'

const MobileViewAccordion = (props) => {
    const { loaderVisible, tableSearch, requestTypeChangeFunction, handleSearchChange, csvExportFunction, isExporting,
        finalData, orderFilterState, handleFilterStateChange, handleStatusChange, filterCities, states,
        statusList, pageCount, page, handleChange, callFetchApi, callBack } = props
    const [filterPopUpModal, setFilterPopUpModal] = useState(false);
    const [isOpen, setIsOpen] = useState([]);

    const toggleAccordion = (index) => {
        const newIsOpen = [...isOpen];
        newIsOpen[index] = !newIsOpen[index];
        setIsOpen(newIsOpen);
    };

    return (
        <MobileViewWrapper>
            {loaderVisible && <Spinner />}
            <TableWrapper>
                <div>
                    <div class="community-details-header seller">
                        <div class="community-name">
                            <h4>{orderFilterState.requestType === 'Delivery' ? 'My Order Report' : 'My Pickup Order Report'}</h4>
                        </div>
                        <p style={{ cursor: 'pointer', fontFamily: 'latomedium', marginRight: '7px' }}
                            onClick={() => setFilterPopUpModal(true)}
                        ><FilterIcon /> Filter</p>
                    </div>
                    <div className="request-type-class" style={{ marginBottom: '15px', justifyContent: 'end' }}>
                        <p>Request Type : </p>
                        <SelectWrapper>
                            <select
                                style={selectStyle}
                                id="requestType"
                                value={orderFilterState.requestType}
                                onChange={requestTypeChangeFunction}
                            >
                                {requestTypeList.map((data, index) => {
                                    return <option value={data.value}>{data.label}</option>;
                                })}
                            </select>
                        </SelectWrapper>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <SearchWrapper>
                            <input
                                style={{ border: "1px solid #69BBE0", borderRadius: "5px" }}
                                type="text"
                                placeholder='Search'
                                value={tableSearch}
                                onChange={handleSearchChange}
                            />
                            <AiOutlineSearch />
                        </SearchWrapper>
                        <div>
                            <button
                                disabled={finalData && finalData?.length === 0}
                                style={greenButton}
                                onClick={csvExportFunction}
                            >{isExporting ? 'Exporting...' : 'Export'}
                            </button>
                        </div>
                    </div>
                </div>
            </TableWrapper>
            {finalData?.map((item, index) => (
                <div key={index} className={`mobile-accordion ${isOpen[index] ? 'open' : ''}`}>
                    <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                        <div className="accordion-header-left">
                            <div className="info">
                                <h6>Order ID</h6>
                                <p style={{ minWidth: '150px' }}>{item.orderId}</p>
                            </div>
                            <div className="info">
                                <h6>Status</h6>
                                <p>{item.orderStatus === 'CANCELLED' ? 'CANCELED' : item.orderStatus}</p>
                            </div>
                        </div>
                        <div className="accordion-header-right">
                            <p>{isOpen[index] ? <UpArrow /> : <DownArrow />}</p>
                        </div>
                    </div>
                    {isOpen[index] && (
                        <div className="accordion-content">
                            <div className="accordion-column">
                                <div className="info-header2">
                                    <div className="info">
                                        <h6>Invoice No</h6>
                                        <p>{(item?.userType === 'BUYER' ? item?.invoiceDet?.buyerInvoiceId : item?.invoiceDet?.sellerInvoiceId) || "NA"}</p>
                                    </div>
                                    <div className="info">
                                        <h6>Reference Number</h6>
                                        <p>{(item.ptplusRefNumber && item?.userType === 'SELLER') ? item.ptplusRefNumber : "NA"}</p>
                                    </div>
                                </div>
                                <div className="info-header1">
                                    <div className="info">
                                        <h6>Other Party</h6>
                                        <p>{item.userType === "SELLER" && `${item.buyerInfo?.locationName}, ${item.buyerInfo?.city}, ${stateConvert(item.buyerInfo?.state) || item.buyerInfo?.state}`}
                                            {item.userType !== "BUYER" && `${item.sellerInfo?.locationName}, ${item.sellerInfo?.city}, ${stateConvert(item.sellerInfo?.state) || item.sellerInfo?.state}`}
                                        </p>
                                    </div>
                                </div>
                                <div className="info-header3">
                                    <div className="info">
                                        <h6>Requested Date</h6>
                                        <p>{moment(item.pickupDate).format("MM/DD/YYYY")}</p>
                                    </div>
                                    <div className="info">
                                        <h6>Payment Initiated Date</h6>
                                        <p>{item.initiatePaymentDate || 'NA'}</p>
                                    </div>
                                    <div className="info">
                                        <h6>Quantity</h6>
                                        <p>{item.quantity}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            ))}
            {finalData?.length === 0 && (
                <p style={{ position: "absolute", width: "100%", textAlign: "center", }}>
                    No record found
                </p>
            )}
            {finalData?.length !== 0 && (
                <div style={{ margin: '25px 0' }}>
                    <Pagination count={pageCount} page={page} onChange={handleChange} />
                </div>
            )}
            <FilterModal
                isOpen={filterPopUpModal}
                orderFilterState={orderFilterState}
                handleFilterStateChange={handleFilterStateChange}
                handleStatusChange={handleStatusChange}
                toggle={() => setFilterPopUpModal(!filterPopUpModal)}
                filterCities={filterCities}
                states={states}
                statusList={statusList}
                callBack={(type, resetValues) => {
                    if (type === 'clear') {
                        callBack(resetValues)
                    } else if (type === 'apply') {
                        setFilterPopUpModal(false)
                        callFetchApi()
                    }
                }}
            />
        </MobileViewWrapper>
    );
};

export default MobileViewAccordion;
